module.exports = __webpack_public_path__ + "media/frontend/assets/icons/icon-recall-0a40717356ac42293b11c42d492385fa.png";